import { DomainButton } from "./DomainButton";
import { useNavigate } from "react-router-dom";

export function BackButton({ children, className, btnSize, size, link }) {
  const navigate = useNavigate();
  return <DomainButton className={className} onClick={() => navigate(link ?? -1)} btnSize={btnSize} size={size}>
    {children}
  </DomainButton>
}